import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit {
  private _src: string | undefined
  @Input()
  public get src() {
    return this._src;
  }
  public set src(value) {

    this._src = value
    if(this.videoplayer)
    this.videoplayer.nativeElement.load()
  }
  @Input() type: string | undefined;



  private _tracks!: any[] ;
  @Input()
  public get tracks() {
    return this._tracks;
  }
  public set tracks(value) {
    this._tracks = value
  }
  @ViewChild("videoPlayer") videoplayer!: ElementRef;

  constructor() {

  }

  ngOnInit() {
  }

  setVideoSource() {

    this.videoplayer.nativeElement.load()
  }

  onChange(UpdatedValue: string): void {

  }

}
